// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gAVkR","body":"styles_body__gXMHJ","footer":"styles_footer__FFybu","btn":"styles_btn__eZvIP","cancel":"styles_cancel__iYaMf"};